export default __webpack_public_path__ + "static/2b2b7939-693b-44cd-873a-1aa065a906b8-3751a8117aa27ba9fb4943beb56d7c6c.woff";